import * as React from 'react';
import AntAlert, { AlertProps as AntAlertProps } from 'antd/lib/alert';
import classNames from 'classnames';

import styles from './Alert.module.scss';
export interface AlertProps extends AntAlertProps {
	autoClose?: boolean;
	isStatic?: boolean;
	resetAlert?: () => void;
}

const ALERT_DELAY = 5000;

class Alert extends React.Component<AlertProps> {
	componentDidUpdate() {
		const { autoClose, message } = this.props;
		if (message && autoClose) {
			setTimeout(this.onAlertClose, ALERT_DELAY);
		}
	}
	onAlertClose = (e?: any) => {
		if (e) {
			e.stopPropagation();
		}
		if (this.props.resetAlert) {
			this.props.resetAlert();
		}
	};

	render() {
		const { message, className, isStatic } = this.props;
		if (!message) {
			return null;
		}
		return (
			<AntAlert
				{...this.props}
				onClose={e => this.onAlertClose(e)}
				className={classNames(styles.alert, className, isStatic ? styles.alertStatic : '')}
			/>
		);
	}
}

export default Alert;
